// Per-field Czech labels for audit-history rendering.
// Source: derived 1:1 from BE @AuditLabel annotations
// Keyed by entityType -> fieldName -> Czech label.

export const FIELD_LABELS = {
  Address: {
    country: "Stát",
    municipality: "Obec",
    municipalityId: "Obec (číselník)",
    street: "Ulice",
    orientationNumber: "Číslo popisné",
    zip: "PSČ",
  },
  Cadastre: {
    code: "Kód",
    municipalityCode: "Kód obce",
  },
  ChattelType: {
    behavior: "Chování",
  },
  Country: {
    code: "Kód",
  },
  DictionaryObject: {
    name: "Název",
    order: "Pořadí",
    active: "Aktivní",
  },
  FinancialInstitution: {
    name: "Název",
    ic: "IČO",
    contactPerson: "Kontaktní osoba",
    phone: "Telefon",
    email: "E-mail",
    accountValidityFrom: "Platnost účtu od",
    accountValidityTo: "Platnost účtu do",
    note: "Poznámka",
    aisvRegistered: "Registrace v AISV",
  },
  Help: {
    text: "Text nápovědy",
    placement: "Umístění",
  },
  Initiative: {
    official: "Funkcionář",
    text: "Text",
    note: "Poznámka",
    forwardedDate: "Datum postoupení",
    person: "Oznamovatel (fyzická osoba)",
    legalPerson: "Oznamovatel (právnická osoba)",
    processingDate: "Datum zpracování",
    organization: "Orgán, kterému byl podnět předán",
    legitimateAuthority: "Oprávněný orgán",
    state: "Stav",
    result: "Výsledek",
    attachments: "Přílohy",
    resultAttachments: "Výsledné přílohy",
    rejectText: "Důvod odmítnutí",
    archived: "Archivováno",
    forwardingComment: "Komentář k postoupení",
    forwardingReasons: "Důvody postoupení",
    assignedTo: "Přiděleno (pracovník)",
    assignedDate: "Datum přidělení",
  },
  LegitimateAuthority: {
    name: "Název",
    officials: "Přiřazení funkcionáři",
    createNote: "Důvod vytvoření",
    deleteNote: "Poznámka při výmazu",
  },
  Municipality: {
    code: "Kód",
    orpCode: "Kód ORP",
    orp: "ORP",
    fullName: "Celý název",
  },
  Official: {
    titleBefore: "Titul před",
    firstName: "Jméno",
    middleName: "Další jména",
    lastName: "Příjmení",
    titleAfter: "Titul za",
    birthDate: "Datum narození",
    birthAddress: "Adresa narození",
    idCardNumber: "Číslo OP",
    email: "Email",
    visibility: "Viditelnost",
    wpVisibility: "Viditelnost funkcí",
    changedPassword: "Heslo změněno",
    loginDetailsSent: "Přihlašovací údaje odeslány",
    deliveryAddress: "Adresa pro doručování",
    appealDate: "Datum zaslání výzvy",
    checkedState: "Stav kontroly",
    aisvRegistered: "Registrace v AISV",
    deputy: "Poslanec",
    deputyAndOthers: "Poslanec a jiná funkce",
    senator: "Senátor",
    senatorAndOthers: "Senátor a jiná funkce",
    promiseDocumented: "Slib doložen",
    judge: "Soudce",
    government: "Vláda",
    archived: "Archivace",
    lastStatementDate: "Datum posledního oznámení",
    deathDate: "Datum úmrtí",
    permanentAddress: "Adresa trvalého pobytu",
    permanentAddressUpdateDate: "Datum aktualizace adresy",
  },
  OfficialWorkingPosition: {
    workingPosition: "Pozice",
    start: "Začátek",
    end: "Konec",
    organization: "Organizace",
    dateOfStart: "Datum nástupu",
    dateOfEnd: "Datum ukončení",
    writtenDateOfEnd: "Datum písemného oznámení o ukončení",
    archived: "Archivace",
    released: "Stav uvolnění",
  },
  OfficialEsmEntry: {
    esmFunction: "Veřejná funkce",
    validFrom: "Od data",
    validTo: "Do data",
  },
  OtherContractType: {
    type: "Druh",
  },
  Ovm: {
    ic: "IČO",
    subject: "Název",
    abbreviation: "Zkratka",
    organization: "Orgán",
    officialsCount: "Počet funkcionářů",
    deputyOrSenator: "Poslanecká / senátorská kancelář",
    createNote: "Důvod vytvoření",
    deleteNote: "Poznámka při výmazu",
    aisvRegistered: "Registrace v AISV",
  },
  Person: {
    firstName: "Jméno",
    middleName: "Další jména",
    lastName: "Příjmení",
    address: "Adresa",
    email: "Email",
    telephone: "Telefon",
    databox: "Datová schránka",
    idCardNumber: "Číslo OP",
    deliveryAddress: "Doručovací adresa",
    birthDate: "Datum narození",
  },
  RealtyType: {
    type: "Druh",
  },
  Request: {
    person: "Žadatel (fyzická osoba)",
    legalPerson: "Žadatel (právnická osoba)",
    text: "Text žádosti",
    state: "Stav",
    firstViewDate: "Datum prvního nahlédnutí",
    rejectText: "Důvod odmítnutí",
    isPublic: "Žádost vytvořena uživatelem",
    archived: "Archivace",
    viewAll: "Přístup ke všem funkcionářům",
    validity: "Platnost přístupu",
    attachments: "Přílohy",
    adminFiles: "Soubory správce",
    assignedTo: "Přiřazeno referentovi",
  },
  Statement: {
    type: "Druh",
    fromDate: "Od",
    toDate: "Do",
    chattels: "Movité věci",
    chattelsBefore: "Movité věci (před zahájením funkce)",
    commercialPapers: "Cenné papíry",
    commercialPapersBefore: "Cenné papíry (před zahájením funkce)",
    corporationShares: "Podíly v korporaci",
    corporationSharesBefore: "Podíly v korporaci (před zahájením funkce)",
    realties: "Nemovitosti",
    realtiesBefore: "Nemovitosti (před zahájením funkce)",
    incomes: "Příjmy",
    liabilities: "Závazky",
    media: "Média",
    organizationMember: "Členství v organizaci",
    otherContracts: "Ostatní smlouvy",
    naturalPersonBusinesses: "Podnikání (FO)",
    legalBusinessAssociates: "Společníci (PO)",
    officialWorkingPositions: "Pracovní pozice",
    late: "Pozdní",
    visibility: "Viditelnost",
    checked: "Zkontrolováno",
    checkedDate: "Datum kontroly",
    naturalPersonBusinessesEnabled: "Podnikání povoleno",
    commercialPapersEnabled: "Cenné papíry povoleno",
    commercialPapersBeforeEnabled: "Cenné papíry před zahájením funkce povoleno",
    corporationSharesEnabled: "Podíl korporace povoleno",
    corporationSharesBeforeEnabled: "Podíl korporace před zahájením funkce povoleno",
    chattelsEnabled: "Jiné věci povoleno",
    chattelsBeforeEnabled: "Jiné věci před zahájením funkce povoleno",
    incomesEnabled: "Příjmy povoleno",
    organizationMemberEnabled: "Člen statutárního orgánu povoleno",
    otherContractsEnabled: "Další činnost povoleno",
    legalBusinessAssociatesEnabled: "Společník povoleno",
    realtiesEnabled: "Nemovitost povoleno",
    realtiesBeforeEnabled: "Nemovitost před zahájením funkce povoleno",
    liabilitiesEnabled: "Závazky povoleno",
    mediaEnabled: "Média povoleno",
    workingPositionDate: "Datum začetí/ukončení funkce",
    state: "Stav",
    viewConsentState: "Stav souhlasu se zobrazením",
    creationDate: "Datum podání",
    lastModified: "Datum poslední změny",
    archived: "Archivace",
    hasFileRef: "Má soubory",
    senator: "Senátor",
  },
  User: {
    allowKerberos: "Povoleno přihlášení přes Kerberos/LDAP",
    allowDatabox: "Povoleno přihlášení přes datovou schránku",
    allowBasic: "Povoleno přihlášení přes jméno + heslo",
    userDn: "LDAP uživatel",
    databox: "Datová schránka",
    username: "Přihlašovací jméno",
  },
  WorkingPosition: {
    organization: "Orgán",
    visibility: "Viditelnost",
  },
};

/**
 * Resolve Czech field label for a given entityType + fieldName.
 *
 * Looks up FIELD_LABELS[entityType][field]; falls back through:
 *   1. DictionaryObject base map (for `name`, `order`, `active` on every dictionary).
 *   2. User base map (for fields inherited by all User subtypes — Official, PublicUser, InternalUser, etc.).
 *
 * Returns null on miss (NOT the raw field name) so callers can chain to other
 * label sources (e.g., pre-set fieldLabel from the Statement redline summary).
 */
export function fieldLabel(entityType, field) {
  if (!field) return null;
  const direct = FIELD_LABELS[entityType] && FIELD_LABELS[entityType][field];
  if (direct) return direct;
  const fromDict = FIELD_LABELS.DictionaryObject[field];
  if (fromDict) return fromDict;
  const fromUser = FIELD_LABELS.User[field];
  if (fromUser) return fromUser;
  return null;
}
